import { render, staticRenderFns } from "./LeftRightLabel.vue?vue&type=template&id=5028593a&scoped=true&"
import script from "./LeftRightLabel.vue?vue&type=script&lang=js&"
export * from "./LeftRightLabel.vue?vue&type=script&lang=js&"
import style0 from "./LeftRightLabel.vue?vue&type=style&index=0&id=5028593a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028593a",
  null
  
)

export default component.exports